module.exports = function(e, n) {
  return n.includes(e);
};
